/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  mutation TestVendorAccountMutation($vendorAccountId: ID!, $encoding: SMS_BUILT_TYPE!, $sourceAddress: String!, $destinationAddress: String!, $displayName: String!, $shortMessage: String!) {
    TestVendorAccount(vendorAccountId: $vendorAccountId, encoding: $encoding, sourceAddress: $sourceAddress, destinationAddress: $destinationAddress, displayName: $displayName, shortMessage: $shortMessage) {
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
